jQuery(document).ready(function ($) {

    if( $( '.section-training-faq' ).length ) {
        
        $( ".faq-question" ).click( function() {
            // close other answers that are open
            if( !$(this).hasClass('answer-open') ) {
                $( '.section-training-faq .answer-open' ).next( '.faq-answer' ).slideToggle('350');
                $( '.section-training-faq .answer-open' ).removeClass('answer-open');
            }
            // open clicked answer
            $( this ).toggleClass( 'answer-open' );
            $( this ).next( '.faq-answer' ).slideToggle('350');
        } );
    }
});